import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/galactic-republic': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 504c-136.8 0-248-111.3-248-248s111.3-248 248-248 248 111.3 248 248-111.3 248-248 248zM248 24.5c-127.6 0-231.5 103.8-231.5 231.5s103.8 231.5 231.5 231.5 231.5-103.8 231.5-231.5-103.8-231.5-231.5-231.5zM275.6 46.3c37.7 4.9 72.2 19.7 101 41.8l-17.4 17.4c-20.7-15.3-58.1-30.8-83.6-34.5v-24.6zM220.3 46.4v24.5c-31 4.6-59.5 16.8-83.5 34.7h-0.1l-17.3-17.4c28.7-22 63.2-36.9 100.9-41.8zM232.5 96.6h31v82.9c10 2 19.4 6 27.6 11.5l58.7-58.7 21.9 21.9-58.7 58.7c5.5 8.2 9.5 17.6 11.5 27.6h82.9v31h-82.9c-2 10-6 19.3-11.5 27.5l58.7 58.7-21.9 21.9-58.7-58.7c-8.3 5.5-17.6 9.5-27.6 11.5v82.9h-31v-82.9c-8.3-1.7-20.7-6.8-27.7-11.5l-58.6 58.6-21.9-21.9 58.7-58.7c-5.5-8.2-9.5-17.5-11.5-27.5h-82.9v-31h82.9c2-10 6-19.4 11.5-27.6l-58.7-58.7 21.9-21.9 58.6 58.6c8.3-5.5 17.6-9.4 27.7-11.4v-82.9zM415.7 127.3c22.1 28.7 37 63.3 41.9 101h-24.6c-3.8-25.5-19.3-63-34.7-83.7zM80.2 127.4l17.4 17.4c-17.8 24.1-30 52.6-34.6 83.5h-24.7c4.9-37.6 19.8-72.2 41.9-100.9zM38.3 283.7l24.7 0c4.6 31 16.7 59.5 34.5 83.5l-17.4 17.4c-22-28.7-36.9-63.3-41.8-100.9zM433 283.7h24.6c-5 37.7-19.9 72.2-41.9 101l-17.4-17.4c17.9-24.1 30.1-52.6 34.7-83.6zM136.7 406.4c24.1 17.9 52.6 30 83.6 34.7v24.6c-37.7-5-72.2-19.8-101-41.9zM359.2 406.4h0.1l17.3 17.4c-28.8 22.1-63.3 36.9-101 41.8v-24.6c31-4.6 59.5-16.8 83.6-34.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/galactic-republic.js
// module id = 843
// module chunks = 0